import React from 'react'
import {   Field} from 'redux-form'

export class SVString extends React.Component{
    

    constructor(props){
        super(props)


    }
  
    componentWillReceiveProps(next){
        console.log('props changed SVString')

    }
   

    render(){
        console.log('render SVNumber')
        console.log(this.props)

        let me = this

        const  {svshow, svhide, portId, portName, portTypes, locationId, locationText,locationTypes,  children} = this.props
        const portEntryId="sv"+portId
/*
        const {label,label_forName, input, type,
            meta:{
              touched, error, warning
            }
           } = this.props*/
          return (
           <Field  className="form-control"  type="text" placeholder="2" component="input" name={portEntryId } id={portEntryId} placeholder={portEntryId} >
        
          </Field> )
           {/*  return (<div className="form-group">
                <label  forName={label_forName}>{label}
                </label>
                <input   onBlur={() => console.log('sv') }  {...input} type={type} id={portEntryId} className="form-control" placeholder="SVparalleltask"  />
                { touched && ((error && <span>{error}</span> )) || (warning && <span>{warning}</span>) }
            
            </div>
      
             )  
            */}
       

    }
}